import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppResources } from '@app/app.resources';
import { AuthService } from '@app/services';
import { environment } from '@env/environment';

@Component({
    templateUrl: './frame.view.html',
    styleUrls: ['./frame.style.scss'],
})
export class FrameView {
    /**
     * Loading Indicator
     */
    isLoading = true;

    settingsConfigured = true;

    payrollDigest: any[] = [];
    settings: any = {};
    showArchived = false;
    events: any[] = [];

    url: SafeUrl;
    xFrame: HTMLElement;

    private authenticated = false;

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private http: HttpClient,
        private router: Router
    ) {
        this.getAuthRedirectUrl();
    }

    getAuthRedirectUrl(): Promise<any> {
        return this.http
            .get(AppResources.PayrollSession.replace(':employee', this.auth.employee.id.toString()))
            .toPromise()
            .then((res) => {
                try {
                    const url = res['data']['attributes']['location'];
                    this.navigateByUrl(url);
                    this.waitForElement('.main.no-sidebar', 20).then(() => {
                        this.authenticated = true;
                        this.ngOnInitDeferred();
                    });
                } catch (e) {
                    this.router.navigate(['/forbidden']);
                }
            })
            .catch(() => this.router.navigate(['/forbidden']));
    }

    iframeLoaded(): void {
        const contents = $('#payroll').contents();

        if ($('#payroll').attr('src') && contents) {
            this.findFrame();
        }

        if (!this.authenticated) {
            return;
        }

        this.isLoading = false;
    }

    waitForElement(selector: string, maxTimeout = 10): Promise<HTMLElement> {
        return new Promise<HTMLElement>((resolve, reject) => {
            let timeout = 0;
            const interval = setInterval(() => {
                if (this.xFrame) {
                    if (this.checkElementExist(this.xFrame, selector)) {
                        clearInterval(interval);
                        resolve($(this.xFrame).find(selector));
                    }
                }
                if (timeout > maxTimeout) {
                    clearInterval(interval);
                    reject('Element not found after 5 seconds');
                }
                timeout++;
            }, 500);
        });
    }

    ngOnInitDeferred(): void {
        this.route.queryParams.subscribe(() => {
            if (this.route.snapshot.queryParams.url) {
                this.navigateByUrl(this.route.snapshot.queryParams.url);
                return;
            }

            const view = this.route.snapshot.queryParams.view;
            switch (view) {
                case 'overview':
                    this.navigateBySelector('a[href="/"]');
                    break;
                case 'payroll':
                    this.navigateBySelector('a[href="/payroll"]');
                    break;
                case 'people':
                    this.navigateBySelector('a[href="/team"]');
                    break;
                case 'records':
                    this.navigateBySelector('a[href="/records"]');
                    break;
                case 'company':
                    this.navigateBySelector('a[href="/company"]');
                    break;
                case 'profile':
                    this.navigateBySelector('a[href="/profile"]');
                    break;
                case 'settings':
                    this.navigateBySelector('a[href="/settings"]');
                    break;
            }
        });
    }

    private sanatizeUrl(url: string): SafeUrl {
        if (!environment.production) {
            url = url.replace(
                environment.url ?? 'https://localhost:4200',
                environment.payrollUrl ?? 'http://localhost:3030'
            );
        }
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    private navigateByUrl(url: string): void {
        if (!this.url) {
            this.url = this.sanatizeUrl(url);
            this.isLoading = true;
            return;
        }

        const selector = '.main.no-sidebar';
        this.waitForElement(selector)
            .then(() => {
                this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.payrollUrl + url);
                this.isLoading = true;
            })
            .catch((err) => console.error(selector, err));
    }

    private navigateBySelector(selector: string): void {
        this.waitForElement(selector)
            .then((link) => {
                $(link)[0].click();
            })
            .catch((err) => {
                console.error(selector, err);
            });
    }

    private findFrame(): void {
        this.xFrame = $('#payroll')[0].contentWindow.document;

        this.waitForElement('body').then((element) => {
            $(element).css({ backgroundColor: 'var(--grey-100)' });
        });
    }

    private checkElementExist(context: any, selector: string): boolean {
        return !!$(context).find(selector).length;
    }
}
